import React, { useState, useRef } from 'react';
import { Modal, Input, Button, message } from 'antd';
import { bossRoomsApi, BossRoomMap } from '../services/bossRoomsApi';

interface SimpleMapModalProps {
  visible: boolean;
  roomCode: string;
  roomName: string;
  mapId?: number;
  mapData?: BossRoomMap | null;
  onClose: () => void;
  onSave: () => void;
}

const ORIGIN = 'https://cbdungeons.sayberrygames.com';
const PATH = '/map-editor-standalone';

const SimpleMapModal: React.FC<SimpleMapModalProps> = ({ visible, roomCode, roomName, mapId, mapData, onClose, onSave }) => {
  const [mapVersion, setMapVersion] = useState<string>(mapData?.metadata?.name || 'Version 1');
  const editorWinRef = useRef<Window|null>(null);
  const timerRef = useRef<number|undefined>(undefined);

  const openEditorFor = (id: number, phase: number) => {
    const params = new URLSearchParams({ 
      type: 'boss',
      roomCode, 
      roomName, 
      phase: String(phase), 
      mapId: String(id) 
    });
    const url = `${ORIGIN}${PATH}?${params.toString()}`;
    if (editorWinRef.current && !editorWinRef.current.closed) {
      try { editorWinRef.current.location.replace(url); editorWinRef.current.focus(); }
      catch { editorWinRef.current = null; }
    }
    if (!editorWinRef.current || editorWinRef.current.closed) {
      editorWinRef.current = window.open(url, 'MAP_EDITOR', `noopener,noreferrer,width=${Math.max(1280,screen.availWidth-40)},height=${Math.max(800,screen.availHeight-80)}`);
    }
    if (timerRef.current) window.clearInterval(timerRef.current);
    timerRef.current = window.setInterval(()=>{
      if (document.hidden) return;
      const w = editorWinRef.current;
      if (!w || w.closed) {
        window.clearInterval(timerRef.current);
        timerRef.current = undefined;
        onSave();
      }
    }, 1000);
  };

  const handleCreateOrOpen = async () => {
    const phase = parseInt(mapVersion.replace(/[^0-9]/g, '')) || 1;
    try {
      let currentId = mapId;
      if (!mapId) {
        const newMap = await bossRoomsApi.create({ room_code: roomCode, phase, map_code: null, metadata: { name: mapVersion }});
        currentId = newMap?.id;
      } else {
        await bossRoomsApi.update(mapId, { metadata: { ...(mapData?.metadata || {}), name: mapVersion }});
      }
      if (currentId) openEditorFor(currentId, phase);
      onClose();
    } catch (e:any) {
      console.error(e); message.error('맵 슬롯 생성/업데이트 실패');
    }
  };

  return (
    <Modal 
      open={visible} 
      onCancel={onClose} 
      onOk={handleCreateOrOpen} 
      okText={mapId ? '에디터 열기' : '슬롯 생성 후 열기'} 
      title="맵 만들기/편집" 
      destroyOnClose
      className="dark-mode-modal"
      styles={{
        body: { 
          backgroundColor: '#1f1f1f',
          color: '#e8e8e8'
        },
        header: {
          backgroundColor: '#1f1f1f',
          color: '#e8e8e8',
          borderBottom: '1px solid #434343'
        },
        footer: {
          backgroundColor: '#1f1f1f',
          borderTop: '1px solid #434343'
        },
        content: {
          backgroundColor: '#1f1f1f'
        }
      }}
    >
      <div style={{ marginBottom: 8 }}>버전 이름</div>
      <Input value={mapVersion} onChange={(e)=>setMapVersion(e.target.value)} placeholder="예: Version 1"
        style={{ background:'#2d2d2d', borderColor:'#434343', color:'#e8e8e8' }}/>
    </Modal>
  );
};

export default SimpleMapModal;